export const StreakBoardHeader = () => (
  <thead className="font-heebo text-soClean-180 bg-soFresh-130 w-full text-sm font-medium leading-tight tracking-tight">
    <tr className="w-full font-semibold">
      <th className="py-3 pl-16 text-left">Player</th>
      <th className="py-3">Projection</th>
      <th className="py-3">Stat Type</th>
      <th className="py-3">Rank</th>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <th />
    </tr>
  </thead>
);
